import { ActionTree, ActionContext } from 'vuex';
import { RootState } from '@/store';
import { State } from './state';
import { Mutations } from './mutations';
import { ColorpickerMutationTypes as MutationTypes } from './mutation-types';
import { ColorpickerActionTypes as ActionTypes } from './action-types';

type AugmentedActionContext = {
  commit<K extends keyof Mutations>(
    key: K,
    payload: Parameters<Mutations[K]>[1],
  ): ReturnType<Mutations[K]>;
} & Omit<ActionContext<State, RootState>, 'commit'>

export interface Actions {
  [ActionTypes.SET_COLORPICKER_BODY]({ commit }: AugmentedActionContext, payload: string | null): void;
  [ActionTypes.SET_COLORPICKER_EDGE]({ commit }: AugmentedActionContext, payload: string | null): void;
  [ActionTypes.SET_COLORPICKER_EDGE_GLOSINESS]({ commit }: AugmentedActionContext, payload: string | null): void;
  [ActionTypes.SET_COLORPICKER_EDGE_METALNESS]({ commit }: AugmentedActionContext, payload: string | null): void;
  [ActionTypes.SET_COLORPICKER_THREAD]({ commit }: AugmentedActionContext, payload: string | null): void;
  [ActionTypes.SET_COLORPICKER_INSIDE]({ commit }: AugmentedActionContext, payload: string | null): void;
  [ActionTypes.SET_COLORPICKER_TACK]({ commit }: AugmentedActionContext, payload: string | null): void;
}

export const actions: ActionTree<State, RootState> & Actions = {
  [ActionTypes.SET_COLORPICKER_BODY]({ commit }, payload: string | null) {
    commit(MutationTypes.SET_COLORPICKER_BODY, payload);
  },
  [ActionTypes.SET_COLORPICKER_EDGE]({ commit }, payload: string | null) {
    commit(MutationTypes.SET_COLORPICKER_EDGE, payload);
  },
  [ActionTypes.SET_COLORPICKER_EDGE_GLOSINESS]({ commit }, payload: string | null) {
    commit(MutationTypes.SET_COLORPICKER_EDGE_GLOSINESS, payload);
  },
  [ActionTypes.SET_COLORPICKER_EDGE_METALNESS]({ commit }, payload: string | null) {
    commit(MutationTypes.SET_COLORPICKER_EDGE_METALNESS, payload);
  },
  [ActionTypes.SET_COLORPICKER_THREAD]({ commit }, payload: string | null) {
    commit(MutationTypes.SET_COLORPICKER_THREAD, payload);
  },
  [ActionTypes.SET_COLORPICKER_INSIDE]({ commit }, payload: string | null) {
    commit(MutationTypes.SET_COLORPICKER_INSIDE, payload);
  },
  [ActionTypes.SET_COLORPICKER_TACK]({ commit }, payload: string | null) {
    commit(MutationTypes.SET_COLORPICKER_TACK, payload);
  },
};

